import cube from '@cubejs-client/core';
import UserService from '~/auth/UserService';
import { CubeProvider } from '@cubejs-client/react';
import { useMemo } from 'react';
import SupplyOverview from './SupplyOverview';

function SupplyOverviewContainer() {
  const cubeApi = useMemo(
    () =>
      cube(UserService.getToken(), {
        apiUrl: import.meta.env.VITE_ANALYTICS_CUBE_API_BASE_URL,
      }),
    []
  );

  return (
    <CubeProvider cubeApi={cubeApi}>
      <SupplyOverview />
    </CubeProvider>
  );
}

export default SupplyOverviewContainer;
